import * as Constants from '../constants/Constants';
import {
  getURLQueryStringAsDictionary,
  isMaskApp,
  isSignageSuiteProduct
} from './HelperFunctions';

export const isTurkeyAccount = () => (dispatch, getState) => {
  if (getState().home.selectedProduct) {
    const { groupType } = getState().home.selectedProduct;

    const isTurkeyAccnt =
      getState().modal.storeData.partnerStoreType == Constants.TURKEY_KEY &&
      isLaptopsApp(groupType);
    return isTurkeyAccnt;
  }
  return false;
};

export const isFranceAccount = () => (dispatch, getState) =>
  getState().modal.storeData &&
  getState().modal.storeData.partnerStoreType == Constants.FRANCE_KEY;

export const isOmenLaptopOfTurkeyAccount = () => (dispatch, getState) => {
  if (getState().home.selectedProduct) {
    return (
      dispatch(isTurkeyAccount()) &&
      getState().home.selectedProduct.sku === 'OMN_01'
    );
  }
  return false;
};

export const checkForDesignCompetition = () => () => {
  const URLString = getURLQueryStringAsDictionary();
  if (URLString.design_cmp) {
    return true;
  }
  return false;
};

export const checkForDesignEnterprise = () => () => {
  const URLString = getURLQueryStringAsDictionary();
  if (URLString.design_enterprise) {
    return true;
  }
  return false;
};

export const isBelgiumAccount = () => (dispatch, getState) => {
  if (getState().home.selectedProduct) {
    const { groupType } = getState().home.selectedProduct;

    const isBelgiumAccnt =
      getState().modal.storeData.partnerStoreType == Constants.BELGIUM_KEY &&
      isLaptopsApp(groupType);
    return isBelgiumAccnt;
  }
  return false;
};

export const isWestcoastAccount = () => (dispatch, getState) => {
  if (getState().home.selectedProduct) {
    const { groupType } = getState().home.selectedProduct;

    const issWestcoastAccnt =
      getState().modal.storeData.partnerStoreType == Constants.WESTCOAST_KEY &&
      isLaptopsApp(groupType);
    return issWestcoastAccnt;
  }
  return false;
};

export const isTurkeyLaptop = () => (dispatch, getState) => {
  const { sessionData, storeData } = getState().modal;
  if (
    sessionData.gsku === 'LPTS' &&
    storeData.partnerStoreType === Constants.TURKEY_KEY
  ) {
    return true;
  }
  return false;
};

export const isOmenLaptop = () => (dispatch, getState) => {
  if (getState().home.selectedProduct) {
    return getState().home.selectedProduct.sku === 'OMN_01';
  }
  return false;
};

export const isLaptopsApp = groupType => {
  if (groupType == 'LPTS') {
    return true;
  }
  return false;
};

export const isShippingDetailsEnabled = () => (dispatch, getState) => {
  if (getState().home.selectedProduct) {
    const { groupType } = getState().home.selectedProduct;
    const isEnabled =
      getState().modal.envData.is_shipping_details_enabled &&
      isLaptopsApp(groupType);
    return isEnabled;
  }
  return false;
};

export const orderId = () => {
  const URLString = getURLQueryStringAsDictionary();
  if (URLString.order_id) {
    return URLString.order_id;
  }
  return null;
};

export const couponCodeValue = () => {
  const URLString = getURLQueryStringAsDictionary();
  if (URLString.coupon_code) {
    return URLString.coupon_code;
  }
  if (URLString.Coupon_code) {
    return URLString.Coupon_code;
  }
  return null;
};

export const isBannerApp = groupType => {
  if (groupType == 'BNN') {
    return true;
  }
  return false;
};

export const isRollupApp = groupType => {
  if (groupType == 'RLUP') {
    return true;
  }
  return false;
};

export const isWallcoveringApp = category =>
  category == Constants.WALLPAPER_CATEGORY;

export const isCanvasApp = category => category == Constants.CANVAS_CATEGORY;

export const shouldShowSizeList = () => (dispatch, getState) => {
  if (getState().home.selectedProduct) {
    return (
      isBannerApp(getState().home.selectedProduct.groupType) ||
      isRollupApp(getState().home.selectedProduct.groupType)
    );
  }
  return (
    isWallcoveringApp(getState().modal.envData.category) ||
    isCanvasApp(getState().modal.envData.category)
  );
};

export const canShowPriceDetailsInFinalCheck = () => (dispatch, getState) => {
  if (isSignageSuiteProduct()) {
    const { groupType } = getState().home.selectedProduct;
    return !(isLaptopsApp(groupType) || isMaskApp(groupType));
  }
  return true;
};
